export default {
  baseLayoutSubtitle: 'Applies to every report, unless a report overrides a setting.',
};
